import { baseUrl } from '../network'

export const createCompanyUrl = baseUrl + 'api/company/create'